import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, onUnmounted } from 'vue'
import { initNotifications, stopNotifications } from '@/services/notifications'

const notificationContainerId = 'orcas-notifications'


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationCenter',
  setup(__props) {

onMounted(async () => {
  await initNotifications(notificationContainerId)
})

onUnmounted(() => {
  stopNotifications()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", { id: notificationContainerId }))
}
}

})